'use strict';

export default angular
  .module('maestro.filters.displayLastUpdatedDate', [
    'maestro.filters.calculateTime'
  ])

  .filter('displayLastUpdatedDate', function($filter) {
    let $t = $filter('translate');
    return function(value, phrase) {
      if (value == null || value == '') {
        return '';
      }
      let i18nPhrase = phrase ? 'last-' + phrase + '-date' : 'last-received-date';
      let val = $filter('calculateTime')(value);
      return $t('datetime.' + i18nPhrase, {
        'val': val.count,
        'unit': val.unit
      });
    };
  })

  .name;
